<template>
  <f7-page name="cgm-dashboard" style="background-color:#f7f7f7;">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        우리학원 현황
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>


		<div class="row" style="padding:4px;">
			<div class="thin-border-box top-box col-50 xsmall-50 small-50 medium-33 large-33 xlarge-auto">
				<p>
					<i class="f7-icons">chart_bar_square</i><span>활용지수</span>
				</p>
				<p>
					<span class="text-color-primary">7.4</span>
				</p>
				<p>
					<span>지난달 대비</span> <span>▲ 2%</span>
				</p>
			</div>

      <div class="thin-border-box top-box col-50 xsmall-50 small-50 medium-33 large-33 xlarge-auto">
				<p>
					<i class="f7-icons">person_fill</i><span>학생수</span>
				</p>
				<p>
					<span class="text-color-primary">163</span>
				</p>
				<p>
					<span>지난달 대비</span> <span>▲ 2%</span>
				</p>
			</div>

			<div class="thin-border-box top-box col-50 xsmall-50 small-50 medium-33 large-33 xlarge-auto">
				<p>
					<i class="f7-icons">chart_bar_square</i><span>이번주 학습자수</span>
				</p>
				<p>
					<span class="text-color-primary">112</span>
				</p>
				<p>
					<span>지난주 대비</span> <span>▲ 2%</span>
				</p>
			</div>

      <div class="thin-border-box top-box col-50 xsmall-50 small-50 medium-33 large-33 xlarge-auto">
				<p>
					<i class="f7-icons">person_fill</i><span>이번주 미학습자수</span>
				</p>
				<p>
					<span class="text-color-red">18</span>
				</p>
				<p>
					<span>지난주 대비</span> <span>▲ 2%</span>
				</p>
			</div>

			<div class="thin-border-box top-box col-50 xsmall-50 small-50 medium-33 large-33 xlarge-auto">
				<p>
					<i class="f7-icons">chart_bar_square</i><span>금일 학습자수</span>
				</p>
				<p>
					<span class="text-color-primary">38</span>
				</p>
				<p>
					<span>어제 대비</span> <span>▲ 2%</span>
				</p>
			</div>

      <div class="thin-border-box top-box col-50 xsmall-50 small-50 medium-33 large-33 xlarge-auto">
				<p>
					<i class="f7-icons">person_fill</i><span>금일 학습총량</span>
				</p>
				<p>
					<span class="text-color-primary">62</span>
				</p>
				<p>
					<span>어제 대비</span> <span>▲ 2%</span>
				</p>
			</div>
		</div>

		<div class="row" style="padding:4px">
			<div class="wide-border-box col-100 xsmall-100 small-100 medium-60 large-60 xlarge-60" style="height:300px;">
				<canvas class="total-month-chart" ref="totalMonthChart" style="width:100%; height:100%;"></canvas>
			</div>
			<div class="wide-border-box title-box col-100 xsmall-100 small-100 medium-40 large-40 xlarge-40" style="height:300px;">
				<div class="tb-title">
					<div class="left">
						<h3>이번주 학습지도</h3>
					</div>
					<div class="right">
						<span data-progress="100" class="progressbar" style="width:16px; display:inline-block;"></span> 학생수&nbsp;&nbsp;
						<span data-progress="100" class="progressbar color-green" style="width:16px; display:inline-block;"></span> 학습량
					</div>
				</div>
				<div class="tb-body">
					<div class="progress-group">
						<p>홍길동 선생님</p>
						<p><span data-progress="30" class="progressbar"></span></p>
						<p><span data-progress="50" class="progressbar color-green"></span></p>
					</div>
					<div class="progress-group">
						<p>이순신 선생님</p>
						<p><span data-progress="50" class="progressbar"></span></p>
						<p><span data-progress="70" class="progressbar color-green"></span></p>
					</div>
				</div>
			</div>
		</div>

		<div class="row" style="padding:4px">
			<div class="wide-border-box title-box col-100 xsmall-100 small-100 medium-50 large-50 xlarge-50"  style="height:300px;">
				<div class="tb-title">
					<div class="left">
						<h3>이번주 위험지표</h3>
					</div>
					<div class="right">
						<span data-progress="100" class="progressbar color-red" style="width:16px; display:inline-block;"></span> 퇴원생수&nbsp;&nbsp;
						<span data-progress="100" class="progressbar color-orange" style="width:16px; display:inline-block;"></span> 미학습자수
					</div>
				</div>
				<div class="tb-body">
					<div class="progress-group">
						<p>홍길동 선생님</p>
						<p><span data-progress="30" class="progressbar color-red"></span></p>
						<p><span data-progress="50" class="progressbar color-orange"></span></p>
					</div>
					<div class="progress-group">
						<p>이순신 선생님</p>
						<p><span data-progress="50" class="progressbar color-red"></span></p>
						<p><span data-progress="70" class="progressbar color-orange"></span></p>
					</div>
					<div class="progress-group">
						<p>홍길동 선생님</p>
						<p><span data-progress="30" class="progressbar color-red"></span></p>
						<p><span data-progress="50" class="progressbar color-orange"></span></p>
					</div>
					<div class="progress-group">
						<p>이순신 선생님</p>
						<p><span data-progress="50" class="progressbar color-red"></span></p>
						<p><span data-progress="70" class="progressbar color-orange"></span></p>
					</div>
					<div class="progress-group">
						<p>홍길동 선생님</p>
						<p><span data-progress="30" class="progressbar color-red"></span></p>
						<p><span data-progress="50" class="progressbar color-orange"></span></p>
					</div>
					<div class="progress-group">
						<p>이순신 선생님</p>
						<p><span data-progress="50" class="progressbar color-red"></span></p>
						<p><span data-progress="70" class="progressbar color-orange"></span></p>
					</div>
				</div>
			</div>
			<div class="wide-border-box title-box col-100 xsmall-100 small-100 medium-50 large-50 xlarge-50"  style="height:300px;">
				<div class="tb-title">
					<div class="left">
						<h3>이번주 활동</h3>
					</div>
					<div class="right">
						<span data-progress="100" class="progressbar" style="width:16px; display:inline-block;"></span> 클리닉지&nbsp;&nbsp;
						<span data-progress="100" class="progressbar color-green" style="width:16px; display:inline-block;"></span> 컨텐츠제작
					</div>
				</div>
				<div class="tb-body">
					<div class="progress-group">
						<p>홍길동 선생님</p>
						<p><span data-progress="30" class="progressbar"></span></p>
						<p><span data-progress="50" class="progressbar color-green"></span></p>
					</div>
					<div class="progress-group">
						<p>이순신 선생님</p>
						<p><span data-progress="50" class="progressbar"></span></p>
						<p><span data-progress="70" class="progressbar color-green"></span></p>
					</div>
					<div class="progress-group">
						<p>홍길동 선생님</p>
						<p><span data-progress="30" class="progressbar"></span></p>
						<p><span data-progress="50" class="progressbar color-green"></span></p>
					</div>
					<div class="progress-group">
						<p>이순신 선생님</p>
						<p><span data-progress="50" class="progressbar"></span></p>
						<p><span data-progress="70" class="progressbar color-green"></span></p>
					</div>
					<div class="progress-group">
						<p>홍길동 선생님</p>
						<p><span data-progress="30" class="progressbar"></span></p>
						<p><span data-progress="50" class="progressbar color-green"></span></p>
					</div>
					<div class="progress-group">
						<p>이순신 선생님</p>
						<p><span data-progress="50" class="progressbar"></span></p>
						<p><span data-progress="70" class="progressbar color-green"></span></p>
					</div>
				</div>
			</div>
		</div>

		<div class="row" style="padding:4px">
			<div class="wide-border-box title-box col-100 xsmall-100 small-100 medium-100 large-100 xlarge-100" style="height:300px;">
				<div class="tb-title">
					<div class="left">
						<h3>알림글</h3>
					</div>
					<div class="right">
					</div>
				</div>
				<div class="tb-body">
					<div class="list simple-list no-margin">
						<ul>
							<li>
								<div class="item-content">
									리스트1
								</div>
							</li>
							<li>
								<div class="item-content">
									리스트2
								</div>
							</li>
							<li>
								<div class="item-content">
									리스트3
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

  </f7-page>
</template>

<style lang="scss" scoped>

.thin-border-box {
	border-radius: 4px;
	border: solid 1px #ddd;
	background-color: #fff;
	padding: 6px;
	margin: 4px;
}

.wide-border-box {
	border-radius: 4px;
	border: solid 1px #ddd;
	background-color: #fff;
	padding: 12px;
	margin: 4px;
}

.title-box {
	display: flex;
	flex-direction: column;

	.tb-title {
		display: flex;
		flex-direction: row;
		border-bottom: solid 1px #ddd;
		margin-bottom: 12px;
		
		.left {
			margin-right: auto;
		}

		.right {
			margin-left: auto;
		}

		h3 {
			margin: 0;
			padding: 0 0 4px 0;
		}
	}

	.tb-body {
		flex: 1;
		overflow-y: auto;
		padding-right: 6px;
	}
}

.progress-group {
	margin-bottom: 12px;

	p {
		margin: 2px 0;

		& > .progressbar {
			margin-bottom: 6px;
		}
	}
}

.top-box {
	& > p:nth-child(1) {
		margin:2px 0;
		text-align: center;

		& > i {
			font-size:10px;
		}

		& > span {
			font-size:10px;
		}
	}

	& > p:nth-child(2) {
		margin:2px 0;
		text-align: center;
		line-height: 0.8;

		& > span {
			font-size:30px;
			font-weight:600;
		}
	}

	& > p:nth-child(3) {
		margin:2px 0;
		text-align: center;

		& > span {
			font-size:10px;
		}
	}
}

</style>

<script>
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';
import Chart from 'chart.js';

export default {
  data() {
    return {
      code: "",
      studyList: []
    }
  },
  mounted() {
		this.renderTotalMonthChart();
  },
  methods: {
    renderTotalMonthChart() {
			var _this = this;

			var chartConfig = {
				type: 'line',
				data: {
					labels: ['7월', '8월', '9월', '10월', '11월', '12월'],
					datasets: [
						{
							label: '학생수',
							yAxisID: 'student',
							data: [38, 62, 68, 75, 102, 88],
							backgroundColor: '#00ffaaa0',
							borderColor: '#00ffaaff',
							borderWidth: 2,
							fill: false,
						},
						{
							label: '총학습량',
							yAxisID: 'study',
							data: [3800, 62000, 6800, 75000, 1020, 8800],
							backgroundColor: '#00aaffa0',
							borderColor: '#00aaffff',
							borderWidth: 2,
							fill: true,
						}
					]
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					title: {
						display: false,
						text: ''
					},
					tooltips: {
						mode: 'index',
						intersect: false,
					},
					hover: {
						mode: 'nearest',
						intersect: true
					},
					legend: {
						display: true,
						position: 'top',
						align: "end"
					},
					scales: {
						xAxes: [{
							display: true,
							scaleLabel: {
								display: false,
								labelString: '월'
							}
						}],
						yAxes: [{
							id: 'student',
							display: true,
							position: 'left',
							type: 'linear',
							ticks: {
								precision: 0,
								fontColor: '#00ffaaff'
							},
							scaleLabel: {
								display: false,
								labelString: '학생수'
							}
						},{
							id: 'study',
							display: true,
							position: 'right',
							type: 'linear',
							ticks: {
								precision: 0,
								fontColor: '#00aaffff'
							},
							scaleLabel: {
								display: false,
								labelString: '학습총량'
							}
						}]
					}
				}
			};

			var ctx = _this.$refs.totalMonthChart.getContext('2d');
			var chartObj = new Chart(ctx, chartConfig);
		},
  }
}

</script>